import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { BankCertificateInfoComponent } from './shared/bank-certificate-info/bank-certificate-info.component';
import { HomeComponent } from './components/home/home.component';
import { authGuard } from './core/guards/auth.guard';
import { WhyEgyptComponent } from './components/why-egypt/why-egypt.component';
import { WhyChoseEgyptComponent } from './components/aboutEgypt/why-chose-egypt/why-chose-egypt.component';
import { MainIndicatorsComponent } from './components/aboutEgypt/main-indicators/main-indicators.component';
import { SuccessStoresComponent } from './components/aboutEgypt/success-stores/success-stores.component';
import { DevelopmentComponent } from './components/aboutEgypt/development/development.component';
import { YouthComponent } from './components/aboutEgypt/youth/youth.component';
import { SsoCallbackComponent } from './features/sso-callback/sso-callback.component';
import { MainwhyEgyptComponent } from './components/mainwhy-egypt/mainwhy-egypt.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { MediacenterComponent } from './components/mediacenter/mediacenter.component';
import { MedianewsComponent } from './components/medianews/medianews.component';
import { MediaactionsComponent } from './components/mediaactions/mediaactions.component';
import { MediaVideosComponent } from './components/media-videos/media-videos.component';
import { AllServicesComponent } from './components/all-services/all-services.component';
import { GoaheadComponent } from './components/goahead/goahead.component';
import { HelpComponent } from './components/help/help.component';
import { InvestmentSectorsComponent } from './components/investment-sectors/investment-sectors.component';
import { EgyptionsComponent } from './components/egyptions/egyptions.component';

import { AgreementsComponent } from './components/agreements/agreements.component';
import { EconomicperformanceComponent } from './components/economicperformance/economicperformance.component';
import { RealStateComponent } from './components/real-state/real-state.component';
import { MiningComponent } from './components/mining/mining.component';
import { ItComponent } from './components/it/it.component';
import { HealthcareComponent } from './components/healthcare/healthcare.component';
import { FinancialComponent } from './components/financial/financial.component';
import { EducationComponent } from './components/education/education.component';
import { PharmaceuticalComponent } from './components/pharmaceutical/pharmaceutical.component';
import { OilgasComponent } from './components/oilgas/oilgas.component';
import { FoodprocessingComponent } from './components/foodprocessing/foodprocessing.component';
import { AgricultureComponent } from './components/agriculture/agriculture.component';
import { TourismComponent } from './components/tourism/tourism.component';
import { TextilesComponent } from './components/textiles/textiles.component';
import { SetElectronicsComponent } from './components/set-electronics/set-electronics.component';
import { InvestmentReportsComponent } from './components/investment-reports/investment-reports.component';
import { GoldenPermissionsComponent } from './components/golden-permissions/golden-permissions.component';
import { FreeZonesComponent } from './components/free-zones/free-zones.component';
import { EvaluationComponent } from './components/evaluation/evaluation.component';
import { ComplaintsComponent } from './components/complaints/complaints.component';

import { SendDocsComponent } from './components/send-docs/send-docs.component';
import { CsrComponent } from './components/csr/csr.component';
import { FinancialCheckComponent } from './components/financial-check/financial-check.component';
import { AgentAccreditationComponent } from './components/agent-accreditation/agent-accreditation.component';
import { InvestmentJournalComponent } from './components/investment-journal/investment-journal.component';
import { InvestmentLicensesComponent } from './components/investment-licenses/investment-licenses.component';
import { NonConfusionComponent } from './components/non-confusion/non-confusion.component';
import { AssociationsComponent } from './components/associations/associations.component';
import { CompanyModificationsComponent } from './components/company-modifications/company-modifications.component';
import { FoundationComponent } from './components/foundation/foundation.component';
import { DocsServiceComponent } from './components/docs-service/docs-service.component';
import { CsrServiceComponent } from './components/csr-service/csr-service.component';
import { FinancialServiceComponent } from './components/financial-service/financial-service.component';
import { InvestmentSystemsComponent } from './components/investment-systems/investment-systems.component';
import { BusinessRulesComponent } from './components/business-rules/business-rules.component';
import { RegulationsAndRulesComponent } from './components/regulations-and-rules/regulations-and-rules.component';
import { SuggestedSitesComponent } from './components/suggested-sites/suggested-sites.component';
import { InvestorGuideComponent } from './components/investor-guide/investor-guide.component';
import { SocialResponsibilityComponent } from './components/social-responsibility/social-responsibility.component';
import { InvestorsDisputeComponent } from './components/investors-dispute/investors-dispute.component';
import { InvestorsCenterComponent } from './components/investors-center/investors-center.component';
import { InvestorsAgentsComponent } from './components/investors-agents/investors-agents.component';
import { FrequentlyAskedQuestionsComponent } from './components/frequently-asked-questions/frequently-asked-questions.component';
import { EgyptianCitizenshipComponent } from './components/egyptian-citizenship/egyptian-citizenship.component';
import { EconomicperformanceHelpComponent } from './components/economicperformance-help/economicperformance-help.component';
import { CareEgyptianInvestorsComponent } from './components/care-egyptian-investors/care-egyptian-investors.component';
import { IndoorinvestmentsComponent } from './indoorinvestments/indoorinvestments.component';
import { InvestmentZonesComponent } from './investment-zones/investment-zones.component';
import { NewsDetailsComponent } from './components/news-details/news-details.component';
import { DataStaticComponent } from './data-static/data-static.component';
import { SocialResponsibilityInvestmentComponent } from './social-responsibility-investment/social-responsibility-investment.component';
import { CentralAdministrationResponsibilityComponent } from './central-administration-responsibility/central-administration-responsibility.component';
import { TheExcellenceCompetitionComponent } from './the-excellence-competition/the-excellence-competition.component';
import { EqualOpportunitiesComponent } from './equal-opportunities/equal-opportunities.component';
import { EventsSocialResponsibilitiesComponent } from './events-social-responsibilities/events-social-responsibilities.component';
import { LatestReleasesComponent } from './latest-releases/latest-releases.component';
import { HowwecanhelpcontactusComponent } from './howwecanhelpcontactus/howwecanhelpcontactus.component';
import { RulesInvestmentsAndBusinessComponent } from './rules-investments-and-business/rules-investments-and-business.component';
import { OrganizeRulesComponent } from './organize-rules/organize-rules.component';
import { MoneyRulesComponent } from './money-rules/money-rules.component';

export const routes: Routes = [
  { path: '', redirectTo: 'services/eServices', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'workspace',
    loadChildren: () =>
      import('./features/workspace/workspace.module').then(
        (m) => m.WorkspaceModule
      ),
    canActivateChild: [authGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'whyEgypt',
    component: WhyChoseEgyptComponent,
  },
  {
    path: 'indicators',
    component: MainIndicatorsComponent,
  },
  {
    path: 'success',
    component: SuccessStoresComponent,
  },
  {
    path: 'develpment',
    component: DevelopmentComponent,
  },
  {
    path: 'youth',
    component: YouthComponent,
  },
  { path: 'sso/callback', component: SsoCallbackComponent },

  {
    path: 'mainwhyEgypt',
    component: MainwhyEgyptComponent,
  },
  {
    path: 'under-construction',
    component: UnderConstructionComponent,
  },
  {
    path: 'mediacenter',
    component: MediacenterComponent,
  },
  {
    path: 'medianews',
    component: MedianewsComponent,
  },
  {
    path: 'medianews/:id',
    component: NewsDetailsComponent,
  },
  {
    path: 'mediaActions',
    component: MediaactionsComponent,
  },
  {
    path: 'mediaVideos',
    component: MediaVideosComponent,
  },
  {
    path: 'allServices',
    component: AllServicesComponent,
  },

  {
    path: 'setElectronics',
    component: SetElectronicsComponent,
  },
  {
    path: 'investmentReport',
    component: InvestmentReportsComponent,
  },
  {
    path: 'goldenPermission',
    component: GoldenPermissionsComponent,
  },
  {
    path: 'freeZone',
    component: FreeZonesComponent,
  },
  {
    path: 'evaluation',
    component: EvaluationComponent,
  },
  {
    path: 'compliments',
    component: ComplaintsComponent,
  },

  {
    path: 'goahead',
    component: GoaheadComponent,
  },
  {
    path: 'help',
    component: HelpComponent,
  },
  {
    path: 'investmentSectors',
    component: InvestmentSectorsComponent,
  },

  {
    path: 'Egyptions',
    component: EgyptionsComponent,
  },
  {
    path: 'agreements',
    component: AgreementsComponent,
  },
  {
    path: 'economicPerformance',
    component: EconomicperformanceComponent,
  },
  {
    path: 'realState',
    component: RealStateComponent,
  },

  {
    path: 'mining',
    component: MiningComponent,
  },
  {
    path: 'it',
    component: ItComponent,
  },
  {
    path: 'healthcare',
    component: HealthcareComponent,
  },
  {
    path: 'financial',
    component: FinancialComponent,
  },
  {
    path: 'education',
    component: EducationComponent,
  },
  {
    path: 'pharmaceutical',
    component: PharmaceuticalComponent,
  },
  {
    path: 'tourism',
    component: TourismComponent,
  },
  {
    path: 'agriculture',
    component: AgricultureComponent,
  },
  {
    path: 'textiles',
    component: TextilesComponent,
  },
  {
    path: 'oilgas',
    component: OilgasComponent,
  },
  {
    path: 'foodprocessing',
    component: FoodprocessingComponent,
  },
  {
    path: 'investmentzones',
    component: InvestmentZonesComponent,
  },
  {
    path: 'indoorinvestments',
    component: IndoorinvestmentsComponent,
  },
  {
    path: 'freezones',
    component: FreeZonesComponent,
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./features/services/services.module').then(
        (m) => m.ServicesModule
      ),
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  { path: 'bank-certificate-info', component: BankCertificateInfoComponent },
  { path: 'send-docs', component: SendDocsComponent },
  { path: 'csr', component: CsrComponent },
  { path: 'financial-check', component: FinancialCheckComponent },
  { path: 'agent-accreditation', component: AgentAccreditationComponent },
  { path: 'investment-journal', component: InvestmentJournalComponent },
  { path: 'investment-licenses', component: InvestmentLicensesComponent },
  { path: 'non-confusion', component: NonConfusionComponent },
  { path: 'associations', component: AssociationsComponent },
  { path: 'company-modifications', component: CompanyModificationsComponent },
  { path: 'foundation', component: FoundationComponent },
  { path: 'docs-service', component: DocsServiceComponent },
  { path: 'csr-service', component: CsrServiceComponent },
  { path: 'financial-service', component: FinancialServiceComponent },
  { path: 'investment-systems', component: InvestmentSystemsComponent },
  { path: 'business-rules', component: BusinessRulesComponent },
  { path: 'regulations-and-rules', component: RegulationsAndRulesComponent },
  { path: 'suggested-sites', component: SuggestedSitesComponent },
  { path: 'investor-guide', component: InvestorGuideComponent },
  { path: 'SocialResponsibilityComponent', component: SocialResponsibilityComponent },
  { path: 'InvestorsDisputeComponent', component: InvestorsDisputeComponent },
  { path: 'InvestorsCenterComponent', component: InvestorsCenterComponent },
  { path: 'InvestorsAgentsComponent', component: InvestorsAgentsComponent },
  { path: 'FrequentlyAskedQuestionsComponent', component: FrequentlyAskedQuestionsComponent },
  { path: 'EgyptianCitizenshipComponent', component: EgyptianCitizenshipComponent },
  { path: 'DataStaticComponent', component: DataStaticComponent },
  { path: 'SocialResponsibilityInvestment', component:SocialResponsibilityInvestmentComponent  },
  { path: 'CentralAdministrationResponsibility', component:CentralAdministrationResponsibilityComponent  },
  { path: 'TheExcellenceCompetitionComponent', component: TheExcellenceCompetitionComponent  },
  { path: 'EqualOpportunities', component: EqualOpportunitiesComponent  },
  { path: 'EventsSocialResponsibilitiesComponent', component: EventsSocialResponsibilitiesComponent  },
  { path: 'latestReleases', component: LatestReleasesComponent  },
  { path: 'HowwecanhelpcontactusComponent', component: HowwecanhelpcontactusComponent  },
  { path: 'RulesInvestmentsAndBusinessComponent', component: RulesInvestmentsAndBusinessComponent  },
  { path: 'EconomicperformanceHelpComponent', component: EconomicperformanceHelpComponent },
  { path: 'CareEgyptianInvestorsComponent', component: CareEgyptianInvestorsComponent },
  { path: 'OrganizeRulesComponent', component: OrganizeRulesComponent },
  { path: 'MoneyRulesComponent', component: MoneyRulesComponent },


  { path: '**', redirectTo: 'auth/login' }, // catch-all
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
